import { useCallback } from 'react';
import { startGlobalLoading, stopGlobalLoading } from '../Components/Admin/GlobalLoader/GlobalLoader';

const useApiWithLoader = () => {
    const apiCall = useCallback(async (fetchFunction) => {
        startGlobalLoading();
        try {
            const result = await fetchFunction();
            return result;
        } finally {
            stopGlobalLoading();
        }
    }, []);

    const multipleApiCalls = useCallback(async (fetchFunctions) => {
        startGlobalLoading();
        try {
            const results = await Promise.all(fetchFunctions.map(fn => fn()));
            return results;
        } finally {
            stopGlobalLoading();
        }
    }, []);

    return {
        apiCall,
        multipleApiCalls,
        startLoading: startGlobalLoading,
        stopLoading: stopGlobalLoading
    };
};

export default useApiWithLoader;
